import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-password-strength',
    template: `
    <div class="password-strength-meter">
      <div class="password-strength-meter-bar" [style.width.%]="barWidth" [style.background-color]="barColor"></div>
    </div>
  `,
    styles: [`
    .password-strength-meter {
      height: 4px;
      background-color: #e0e0e0;
      border-radius: 2px;
      margin-top: 4px;
      overflow: hidden;
    }
    .password-strength-meter-bar {
      height: 100%;
      border-radius: 2px;
      transition: width 0.3s ease, background-color 0.3s ease;
    }
  `],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PasswordStrengthComponent implements OnChanges {
  @Input() password = '';
  @Output() strengthChange = new EventEmitter<number>();

  public barWidth = 0;
  public barColor = 'transparent';

  private readonly colorMap: Record<number, string> = {
    0: 'transparent',
    1: '#F44336',
    2: '#FF9800',
    3: '#FFC107',
    4: '#4CAF50'
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['password']) {
      const strength = this.calculateStrength(this.password || '');
      this.barWidth = (strength / 4) * 100;
      this.barColor = this.colorMap[strength];
      this.strengthChange.emit(strength);
    }
  }

  private calculateStrength(password: string): number {
    if (!password) {
      return 0;
    }

    let score = 0;

    // Length check
    if (password.length >= 8) {
      score++;
    }

    // Uppercase letter
    if (/[A-Z]/.test(password)) {
      score++;
    }

    // Lowercase letter and numbers
    if (/[a-z]/.test(password) && /[0-9]/.test(password)) {
      score++;
    }

    // Special characters
    if (/[^A-Za-z0-9]/.test(password)) {
      score++;
    }

    return score;
  }
}
